import CONSTANTS from '../constants'
import { isLoggedIn } from '../../utils/helper'
import { EMPTY_ARRAY } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	isUserLogin: isLoggedIn(),
	isAuthenticated: false,
	hasError: false,
	data: EMPTY_ARRAY,
	email: null,
	role: null,
	errorMessage: '',
	id: null,
	orgId: ''
}

const ReceiptsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		//LOGIN HANDLING
		case CONSTANTS.GET_RECEIPTS_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.GET_RECEIPTS_SUCCESS:
			return { ...state, loader: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.GET_RECEIPTS_FAILURE:
			return { ...state, loader: false, errorMessage: 'There is some Error' }
		case CONSTANTS.GET_TICKET_DETAILS_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.GET_TICKET_DETAILS_SUCCESS:
			return { ...state, loader: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.GET_TICKET_DETAILS_FAILURE:
			return { ...state, loader: false, errorMessage: 'There is some Error' }
		case CONSTANTS.GET_LOADER_FALSE:
			return { ...state, loader: false }
		default:
			return state
	}
}

export default ReceiptsReducer